<template>
    <a-layout-sider id="silder_nav" v-model="collapsed">
        <div class="logo">
            <img :src="collapsed ? logo_small : logo_big" />
        </div>
        <a-menu
            ref="menu"
            theme="dark"
            mode="inline"
            :selectedKeys="[activeKey]"
            :openKeys="[openKey]"
        >
            <template v-for="item in menuList">
                <a-menu-item
                    :key="item.name"
                    v-if="!item.children"
                    v-show="item.meta.showInMenu"
                    @click="titleClick"
                >
                    <a :href="item.meta.href" target="_blank" v-if="item.meta.href">
                        <a-icon :type="item.meta.icon" v-if="item.meta.icon" />
                        <span>{{ item.meta.title }}</span>
                    </a>
                    <router-link :to="{ path: item.path }" v-else>
                        <a-icon :type="item.meta.icon" v-if="item.meta.icon" />
                        <span>{{ item.meta.title }}</span>
                    </router-link>
                </a-menu-item>
                <a-sub-menu
                    :key="item.name"
                    v-else
                    @titleClick="titleClick"
                    v-show="item.meta.showInMenu"
                >
                    <template slot="title">
                        <a-icon :type="item.meta.icon" v-if="item.meta.icon" />
                        <span>{{ item.meta.title }}</span>
                    </template>
                    <template v-for="el in item.children">
                        <a-menu-item :key="el.name" v-show="el.meta.showInMenu">
                            <a :href="el.meta.href" target="_blank" v-if="el.meta.href">
                                <span>{{ el.meta.title }}</span>
                            </a>
                            <router-link :to="{ path: el.path }">
                                <a-icon :type="el.meta.icon" v-if="el.meta.icon" />
                                <span>{{ el.meta.title }}</span>
                            </router-link>
                        </a-menu-item>
                    </template>
                </a-sub-menu>
            </template>
        </a-menu>
    </a-layout-sider>
</template>

<script>
import { mapState } from 'vuex';
import routers from '@/router/routers';
export default {
    data() {
        return {
            activeKey: '',
            openKey: '',
            logo_big: '/static/img/logo2.png',
            logo_small: '/static/img/logo1.png'
        };
    },
    computed: {
        ...mapState({
            collapsed: (state) => state.collapsed
        }),
        menuList() {
            return routers;
        }
    },
    mounted() {
        if (this.$route.name === 'index') this.$router.push({ path: '/home' });
        this.init();
    },
    watch: {
        $route() {
            this.init();
        }
    },
    methods: {
        init() {
            let match = this.$route.matched;
            this.activeKey = match[match.length - 1].name;
            if (match.length > 2) this.openKey = match[match.length - 2].name;
        },
        titleClick(e) {
            const hasItem = [this.openKey].includes(e.key);
            this.openKey = hasItem ? '' : e.key;
        }
    }
};
</script>

<style>
#silder_nav {
    height: 100vh;
    overflow: auto;
}
#silder_nav .logo {
    color: #fff;
    font-size: 18px;
    text-align: center;
    line-height: 32px;
    text-align: center;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}
#silder_nav img {
    display: inline-block;
    max-width: 100%;
    height: 32px;
    box-sizing: border-box;
}
#silder_nav p {
    width: 100%;
}
</style>
